import axios from "axios";
 
export const axiosClient = axios.create({
  baseURL: "https://admin.advertisingmarketplace.com:8080/api",
});
export const chatBot = axios.create({
  baseURL:
    "https://3tenjocspq7yzga4wx73b773i40sthgx.lambda-url.us-east-1.on.aws",
});
 
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
 
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      redirectToLogin();
      sessionStorage.removeItem("userRole");
 
      return;
    }
    return Promise.reject(error);
  },
);
chatBot.interceptors.request.use((config) => {
  let username = "ampaichatbot";
  let password = "n8XvH67S9ttpPO7E0c-RwkBwxH-74YzYfRJ0z9JWJg4";
  const token1 = btoa(`${username}:${password}`);
  config.headers.Authorization = `Basic ${token1}`;
  return config;
});
 
chatBot.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      redirectToLogin();
      return;
    }
    return Promise.reject(error);
  },
);
export const API_BASE_URL_IMAGE =
  "https://admin.advertisingmarketplace.com:8080";
export const PDF_BASE_URL =
  "https://admin.advertisingmarketplace.com/assets/excelFile";
export const API_NEAR_BY_PRODUCTS =
  "https://admin.advertisingmarketplace.com:8080/api";
export const API_BASE_URL_44 =
  "https://admin.advertisingmarketplace.com:8080/api";
export const chatBotUrl =
  "https://3tenjocspq7yzga4wx73b773i40sthgx.lambda-url.us-east-1.on.aws/chat ";
 
export const ENDPOINTS = {
  LOGIN: `/login`,
  USER_SIGNUP: `/user`,
  CLIENT_SIGNUP: `/client`,
  USER_QUERY: `/user-query`,
  PASSWORD_RESET: `/reset-password`,
  PASSWORD_RESET_REQUEST: `/send-reset-password-link`,
  SEARCH_LOCATION: `/search-loc`,
  SEARCH_CITIES: `/search-cities`,
  GET_LOCATION: `/search-locations`,
  SEARCH_DMAS: `/search-areas`,
  PRODUCTS_LIST_BEFORE_LOGIN: `/filter-products-before-login`,
  NEAR_BY_PRODUCTS: `/get-products-by-lat-long`,
  NEAR_BY_PRODUCTS_BEFORE_LOGIN: `/get-products-by-lat-lng-before-login`,
  RFP_REQUESTS: `/rfp-campaign-records`,
  DELETE_IMAGE_FROM_BILLBOARD: `/delete-image-from-billboard`,
  PRODUCTS_PRICE_PREDICTION: `/get-product-preice-prediction`,
  FILTERS_PRODUCTS: `/get-products-list-map-with-filter`,
  NOTIFICATIONS: `/get-notifications`,
  UPDATE_NOTIFICATIONS: `/update-notifications-status`,
  // Buyer Dashboard
  BUYER_CAMPAIGNS_STATUS_COUNT: `/get-buyer-activities-campaigns`,
 
  // Buyer campaigns
  BUYER_CAMPAINGS: `/active-user-campaigns?tab_status`,
  SEARCH_BUYER_CAMPAINGS: `/search-campaigns`,
  DOWNLOAD_INSERTION_ORDER: `/download-inerstion-order`,
  DOWNLOAD_SIGNED_IO: `/download-signed`,
  DOWNLOAD_QUOTE: `/download-quote`,
  SEARCH_BUYERS: "/search-buyers",
  TRANSFER_CAMPAIGN_TO_BUYER: "transfer-campaign-to-buyer",
  //saved_campaign_get
  BUYER_SAVED_CAMPAIGNS: `/user-saved-campaigns?tab_status=saved_campaign`,
  //saved campaign_post
  BUYER_CREATE_CAMPAIGN: `/get-create-new-existing-campaign`,
  //buyer profile_get
  BUYER_PROFILE: `/user-profile`,
  // buyer profile_post
  BUYER_PROFILE_UPDATE: `/update-user-profile`,
  //buyer profile delete
  BUYER_PROFILE_DELETE: `/delete-image-from-profile`,
  // Buyer campaigns action items
  BUYER_EDIT_CAMPAIGN: `/update-campaign`,
  BUYER_DELETE_CAMPAIGN: `/delete-campaign`,
  BUYER_DULICATE_CAMPAIGN: `/clone-saved-campaign`,
  BUYER_SHARE_CAMPAIGN: `/share-campaign`,
  BUYER_GROSS_FEE: `/campaign-gross-fee-update`,
  BUYER_OFFER_PRICE: `/offer-price`,
  BUYER_REQUEST_RESEARCH: `/find-for-me`,
  BUYER_RFP_SEARCH_CRITERIA: `/rfp-search-criteria-download`,
  DEFAULT_PAYMENT_TERMS: `/get-payment-terms-dropdown`,
  STRIPE_PAYMENTS_CARD: "/stripe-payment-for-campaigns",
  PRODUCT_EXPIRY_NOTIFY: "product-expiry-notify",
  SELECTED_COLS_EXPORT: `/exported-columns/report_campaign`,
  EXPORT_EXCEL: `exported-columns-update`,
  DELETE_MULTIPLE_PRODUCTS: "delete-multiple-products-from-campaign",
  ACTIVATE_USER_ACCOUNT: "user-activate-account",
  USER_RESEND_OTP: "user-resend-otp",
  // Buyer Payments
  PAYMENTS_DOWNLOAD: `/payments-info-download`,
  CHEQUE_PAYMENT: `/save-cheque-for-campaign-payment`,
 
  // Buyer Docusign
  DOCU_SIGN_BUYER: "/initiate-sign",
  DOCU_SIGN_CALLBACK: "/docusign-callback",
  DOCU_SIGN_REFRESH: "/get-refresh-docusign",
  //common-RFP-Submit Form-without-login
  SUBMIT_RFP_FORM: `/rfp-campaign-without-login`,
  //common-RFP-Submit Form-with-login
  SUBMIT_RFP_FORM_WITH_LOGIN: `/rfp-user-campaign`,
  //common-Advertisement with AMP
  ADVERTISEMENT_WITH_AMP_TARGET_AUDIENCE: "/get-ad-positions-before-login",
  ADVERTISEMENT_WITH_AMP_POST: "/upload-ad-details",
 
  //common-user-query or billing enquiry
  USER_QUERY_POST: "/user-query",
  //common-get-user-pricing-modules
  GET_USER_PRICING_MODULES: "/get-user-pricing-modules",
  //common- user-login-password-change
  CHANGE_PASSWORD: "/change-password",
  BUYER_CAMPAIGN: `/user-campaign`,
  AI_RECOMMENDED_PRODUCTS: `/get-recommended-products`,
  ADD_TO_CART: `/save-campaign-to-cart`,
  CART_DETAILS: `/get-campaigns-from-cart`,
  UPDATE_PRODUCT_QUANTITY: `/update-campaign-product-date-quantity`,
  //Seller endpoints
  SELLER_CAMPAIGN_ACTIVITIES: `/get-seller-activities-campaigns-products`,
  SELLER_PAYMENTS_MONTHLY_EARLY: `/get-seller-payments-yearly-monthly`,
  CAMPAIGNS_SELLER: `/user-campaigns-for-owner`,
  PRODUCT_AVAILABILITY_QUANTITY: "product-availabilty-quantity",
  PRODUCT_AVAILABILITY_QUANTITY_BEFORE_LOGIN:
    "get-product-availabilty-quantity-before-login",
  GET_CAMPAIGNS_COUNT: `/get-seller-campaign-tab-count`,
  VIEW_CAMPAIGN_DETAILS: `/campaign-for-owner`,
  OFFER_DETAILS: `/user-offer`,
  OFFER_COMMENTS: `/get-offer-comments`,
  OWNER_PRODUCTS: `/approved-owner-products`,
  GET_PRODUCT_DETAILS: `/owner-product-details`,
  GET_SINGLE_PRODUCT_DETAILS: `/product`,
  GET_SINGLE_PRODUCT_DETAILS_BEFORE_LOGIN: `/get-products-details-before-login`,
  GET_ALL_SELLERS: `/get-all-sellers`,
  GET_ALL_BULK_UPLOADED_PRODUCTS: `/get-bu-products-by-seller`,
  POST_TRANSFER_PRODUCTS: `/products-transfer`,
  SEARCH_PRODUCTS: `/get-products-for-transfer`,
  GET_PRODUCTS_PER_USER: "get-products-by-user",
  UPLOAD_CSV: `/import`,
  PRODUCT_VISIBILITY: `/product-visibility`,
  FEATURED_CAMPAIGNS: `/campaigns-from-products`,
  // seller payment endpoints
  CAMPAIGN_PAYMENTS: `/campaigns-with-payments-owner`,
  UPDATE_CHECKED_UNCHECKED_CART: "/get-update-cart-checked-unchecked",
  // user-offer
  PRODUCT_TYPES: `/formats?type=ooh`,
  PRODUCT_CHANNELS: `/get-channels-by-product-type`,
  PRODUCT_CHANNELS_BEFORE_LOGIN: "/channels-before-login",
  SAVE_PRODUCT_DETAILS: `/save-product-details`,
  SAVE_CLONED_PRODUCT_DETAILS: "/clone-product-details",
  SAVE_USER_DETAILS: `/save-user-details`,
  GET_CAMPAIGNS_FOR_PURCHASE: `/get-payment-review-customize-details`,
  UPDATE_PRODUCTS_EXPIRY_TIME_DOCUSIGN: "/update-products-expiry-time-docusign",
  //upadate the terms of each campaigns
  CAMPAINS_TERM_APPLY_UPDATE: "/save-campaign-terms-multiple",
  //delete terms requested
  DELETE_TERMS_FROM_CHECKOUT: "/remove-terms-from-checkout",
  //chat bot AI Assistant endpoints
  CHAT: `/chat`,
  BUYER_CAMPAIGN_DELETE_FROM_CART: "/delete-campaign-from-cart",
  SELLER_TERMS_REQUESTS: "get-seller-admin-requests-approval?",
  SELLER_TERMS_REQUESTS_UPDATION: "terms-requests-accept-reject",
  // get Ads same for both before and after login
  GET_AD_DETAILS: "/get-ad-details-before-login",
  // buyer and seller chat communication history
  CHAT_COMMUNICATION_HISTORY: "get-in-chat-messages",
  //New Chat Bot Schema
  GET_CHATBOT_SCHEMA: "get-chat-bot-schema",
  CREATE_HOLD_REQUEST: "get-hold-request-create",
  //move product to campaign
  MOVE_PRODUCT_TO_CAMPAIGN: "get-move-product-to-campaign",
  DEFAULT_TERMS_BOOKING_STATUS: "default-terms-booking-status",
  UPDATE_NEGOTIATION_TERMS_STATUS: "get-update-status-terms",
  VARIABLE_CHARGE_RATES: "get-variable-charge-percentages",
  INITIATE_SIGN: "initiate-sign",
  GET_DOWNLOAD_SIGNED: "download-signed",
  CREATE_INSTANT_CAMPAIGN: "get-map-create-campaign",
  GET_RFP_REFRESHED_CAMPAIGN_PRODUCTS: "get-assaign-rfp-products",
};
export function redirectToLogin() {
  setTimeout(() => {
    const currentPath = window.location.pathname + window.location.search;
    sessionStorage.setItem("redirectPath", currentPath);
    localStorage.clear();
    window.location.href = `/login`;
  }, 500);
}
 
 